import { createContext } from 'react';

export interface UserSettings {
  userName: string;
  videoEffects: {
    backgroundBlur: boolean;
    virtualBackground: boolean;
    videoSourceId: string | undefined;
  };
  defaultSettings: {
    publishAudio: boolean;
    publishVideo: boolean;
    captions: boolean;
    audioSource?: string | undefined;
    videoSource?: string | undefined;
    audioOutput?: string | undefined;
  };
}

export interface VonageContextType {
  user: UserSettings | null;
  setUser: React.Dispatch<React.SetStateAction<UserSettings | null>>;
}

export const VonageContext = createContext<VonageContextType>({
  user: null,
  setUser: () => true,
});
